import { DateTime } from "luxon";

export function utcTimeZoneConverter(date: DateTime) {
	return DateTime.fromISO(
		date.toISO({ includeOffset: false }).concat("Z")
	).setZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
}
